import { api } from "@/library/http";

export const getInitData = (hash, options = {}) => {

  const filteredOptions = Object.keys(options)
    .filter(key => options[key] !== false && options[key] !== undefined)
    .reduce((obj, key) => ({ ...obj, [key]: options[key] }), {});

  return api.get('/init-data/', { params: { hash, ...filteredOptions } });
};

export const getInitDataProduct = (id, hash) => api.get(`/init-data/product/${id}`, { params: { hash } });

export const checkDomain = (domain) => api.get(`/domain/check/${domain}`);

export const checkSimilarDomains = (domain, country) => api.post(`/similar-domains/`, undefined,  { params : {domain, country} } );

export const checkPromoCode = (promocode) => api.get(`/promo/${promocode}`);

export const getGateways = (cookie) => api.get('/gateway/fetch-all-available', { headers: { Authorization: cookie } });

export const getGatewaysMonobank = () => api.get('/gateway/fetch-monobank');

export const getAllUpsaleSsl = (cookie) => api.get(`/upsale-ssl/`);
